import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { environment } from '../../environments/environment';
import { OnboardingScreenService } from './onboarding-screen.service';

declare var $: any;

@Component({
    selector: 'app-onboarding-screen',
    templateUrl: './onboarding-screen.component.html',
    styleUrls: ['./onboarding-screen.component.scss']
})
export class OnboardingScreenComponent implements OnInit {
    emailID: any = {};
    teamName: any = {};
    fullName: FormGroup;
    companyName: FormGroup;
    mobilePhone: FormGroup;
    screenForm: FormGroup;
    recaptchaReactive: FormGroup;
    imageList = [];
    window: any = window;
    errMessage: String;
    user: any = {};
    team: any = {};
    companynameExist: Boolean = false;
    errCompanyMessage: String;
    errEmailMessage: String;
    siteKey: String;
    countryCode: String = '1';

    constructor(
        private _formBuilder: FormBuilder,
        private _onboardingScreenService: OnboardingScreenService,
        private _router: Router
    ) { }

    ngOnInit() {
        this.screenForm = this._formBuilder.group({
            emailId: ['', [Validators.required, Validators.email]],
            fullName: ['', [Validators.required, Validators.pattern(/.*[^ ].*/)]],
            companyName: ['', [Validators.required, Validators.pattern(/.*[^ ].*/)]],
            mobilePhone: ['', [Validators.maxLength(15)]],
            recaptchaReactive: new FormControl(Validators.required)
        });

        this.imageList = [
            { imageName: 'assets/images/Atlas_Copco_logo.svg' },
            { imageName: 'assets/images/barrick-client-logo.svg' },
            { imageName: 'assets/images/epiroc-logo.png' },
            { imageName: 'assets/images/lhoist-logo.svg' }

        ];
        this.siteKey = encodeURIComponent(environment.RECAPTCHA_SITE_KEY);

        let win: any = this.window;
        let countryData = win.intlTelInputGlobals.getCountryData();
        let input = document.querySelector('#phone');

        // init plugin
        let iti = win.intlTelInput(input, {
            utilsScript: '../../build/js/utils.js?1537727621611' // just for formatting/placeholders etc
        });

        // populate the country dropdown
        for (let i = 0; i < countryData.length; i++) {
            let country = countryData[i];
            let optionNode = document.createElement('option');
            optionNode.value = country.iso2;
            let textNode = document.createTextNode(country.name);
            optionNode.appendChild(textNode);
        }

        let thisInstance = this;
        // listen to the telephone input for changes
        input.addEventListener('countrychange', function (e) {
            thisInstance.countryCode = iti.getSelectedCountryData().dialCode;
        });
    }


    signUp() {
        // console.log(this.screenForm.value.recaptchaReactive);
        const signUpObj = {
            user: {
                name: this.screenForm.value.fullName,
                email: this.screenForm.value.emailId,
                phone: '+' + this.countryCode + this.screenForm.value.mobilePhone.toString()
            },
            team: {
                name: this.companyName
            },
            'g-recaptcha-response': this.screenForm.value.recaptchaReactive
        };
        if (!this.screenForm.valid) {
            this.validateAllFormFields(this.screenForm);
            return;
        }
        if (this.companynameExist === true) {
            this._onboardingScreenService.signUp(signUpObj)
                .subscribe((result) => {
                    if (result['data'].verificationCode) {

                        this._router.navigateByUrl('/signUpConfirmation?verificationCode=' + result['data'].verificationCode + '&emailId=' + this.screenForm.value.emailId);
                    } else {

                        this._router.navigateByUrl(result['data'].url);
                    }
                }, (err) => {
                    if (err.error.message) {
                        if (err.error.message.includes('company name is in use')) {
                            this.errCompanyMessage = err.error.message;
                        } else {
                            this.errMessage = err.error.message;
                        }
                    }
                    this.screenForm.controls.recaptchaReactive.reset();
                });
        }
    }


    verifyEmailId() {
        this.errEmailMessage = '';
        this.team.emailId = this.screenForm.value.emailId;
        this.team.emailId = _.toLower(this.team.emailId);
        if (this.screenForm.value.emailId === undefined || this.screenForm.value.emailId === '' || this.screenForm.controls.emailId.invalid) {
            return;
        } else {
            this._onboardingScreenService.verifyEmailId(this.team.emailId).subscribe(
                (result: any) => {
                    this.errEmailMessage = '';
                }, (err) => {
                    this.errEmailMessage = err.error.message;
                });
        }

    }
    resetError() {
        this.errEmailMessage = '';
    }


    verifyTeamName() {
        this.companyName = this.screenForm.value.companyName;
        if (this.screenForm.value.companyName === '') {
            return;
        } else {
            // this._onboardingScreenService.verifyTeamName(this.companyName).subscribe(
            //     (result: any) => {
            //         this.errCompanyMessage = '';
            //         this.companynameExist = true;

            //     }, (err) => {
            //         this.errCompanyMessage = err.error.message;
            //     });

            this.errCompanyMessage = '';
            this.companynameExist = true;
        }

    }

    isScreenFieldValid(field: string) {
        return !this.screenForm.get(field).valid && this.screenForm.get(field).touched;
    }

    validateAllFormFields(formGroup: FormGroup) {
        Object.keys(formGroup.controls).forEach(field => {
            console.log(field);
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/onboarding-screen/onboarding-screen.component.ts